<template>
  <div>
    <app-login
        v-if="showLogin"
        @loggedIn="showLogin = false"
    />

    <div v-else class="container">
      <div class="row mt-2 mb-4">
        <div class="col-6">
          <h1>Bro-push-bot</h1>
          <div class="mt-2">
            <!--  Поиск  -->
            <app-search
                @hideResult="showResults = false"
                @searchResult="showSearchResult"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex">
            <!--  Краткая сводка  -->
            <app-total/>
            <div class="ml-3">
              <b-button
                  variant="danger"
                  @click="logout"
              >
                logout
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <!--  Вывод результатов поиска  -->
      <div
          v-if="showResults"
          class="mb-5"
      >
        <h6>Результат поиска</h6>
        <app-user-table
            is-predefined
            :external-items="externalItems"
        />

        <div class="mt-2 border border-gray"></div>
      </div>

      <!--  Таблица пользователей  -->
      <h6>Все пользователи</h6>
      <app-user-table/>
    </div>
  </div>
</template>

<script>
import AppTotal from "@/components/AppTotal.vue";
import AppUserTable from "@/components/AppUserTable.vue";
import AppSearch from "@/components/AppSearch.vue";
import AppLogin from "@/components/AppLogin.vue";
import {eventBus} from "@/eventBus";

export default {
  name: 'App',
  components: {
    AppLogin,
    AppSearch,
    AppUserTable,
    AppTotal
  },
  created() {
    const token = this.getToken()
    if (token) {
      this.showLogin = false
    }
  },
  mounted() {
    eventBus.$on("apiError", this.showApiError);
    eventBus.$on("logout", this.logout);
  },
  beforeUnmount() {
    eventBus.$off("apiError", this.showApiError);
    eventBus.$off("logout", this.logout);
  },
  data() {
    return {
      showLogin: true,
      showResults: false,
      externalItems: [],
    }
  },
  methods: {
    showApiError(msg) {
      const text = msg || 'Ошибка запроса'
      this.$bvToast.toast(text, {
        title: 'Error',
        autoHideDelay: 3000,
        variant: "danger"
      })
    },
    getToken() {
      return localStorage.getItem('token')
    },
    showSearchResult(data) {
      this.externalItems = data
      this.$nextTick(() => {
        this.showResults = true
      })
    },

    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
      this.showLogin = true
    }
  }
}
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
.hidden {
  position: absolute;
  top: -1000px;
  left: -1000px;
  display: none;
  visibility: hidden;
  width: 0;
  height: 0;
  overflow: hidden;
}
</style>
